import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthenticationService } from './authentication.service';

import {
  ApiResponse,
  NotificationsResponse,
  NotificationFilter,
  PartnerResponse,
  CountryResponse,
  CreateNotificationResponse,
  CreateNotificationRequest,
  NotificationDetail
} from '../models/notification';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private readonly baseUrl = `${environment.baseurl.api}`;

  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService
  ) {}
  
  createNotification(
    payload: CreateNotificationRequest
  ): Observable<ApiResponse<CreateNotificationResponse>> {
    return this.http.post<ApiResponse<CreateNotificationResponse>>(
      `${this.baseUrl}/protected/notification/create`, 
      { ...payload, currentUser: this.authenticationService.getCurrentUser()}, 
      this.authenticationService.getHeaders());
}
  getAll(filters: NotificationFilter): Observable<ApiResponse<NotificationsResponse>> {
    return this.http.post<ApiResponse<NotificationsResponse>>(
      `${this.baseUrl}/protected/notification/all`,
      filters,
      this.authenticationService.getHeaders()
    );
  }
  
  getById(id: string): Observable<ApiResponse<NotificationDetail>> {
    return this.http.get<ApiResponse<NotificationDetail>>(
      `${this.baseUrl}/protected/notification/${id}`, this.authenticationService.getHeaders());
    }

  disable(id: string): Observable<ApiResponse<null>> {
    return this.http.post<ApiResponse<null>>(
      `${this.baseUrl}/protected/notification/${id}/disable`,
      {},
      this.authenticationService.getHeaders()
    );
  }

  exportRecipients(id: string) {
    const headers = new HttpHeaders(
      {
        Authorization: `Bearer ${this.authenticationService.getCurrentToken()}`
      });
      return this.http.get(
        `${this.baseUrl}/protected/notification/${id}/recipient/export`,
        {
          headers,
          responseType: 'blob'
        }
      );
    }

  getRetailPartners(): Observable<ApiResponse<PartnerResponse>> {
    return this.http.get<ApiResponse<PartnerResponse>>(
      `${this.baseUrl}/public/partner/all`
    );
  }

  getCountries(): Observable<ApiResponse<CountryResponse>> {
    return this.http.get<ApiResponse<CountryResponse>>(
      `${this.baseUrl}/public/countries`
    );
  }
}
